import SolutionDevices from './SolutionDevices';

export { routes as solutionDevicesRoutes } from './routes';
export default SolutionDevices;
